import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f02ab21"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-filter flex"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("-")


import TableColumnFilter from './TableColumnFilter.vue'
import {
  ref,
  reactive,
  toRaw,
  defineProps,
  defineEmits,
  defineExpose,
  computed,
  watch,
  onMounted,
  onUnmounted,
  nextTick,
  defineComponent
} from 'vue'
import { throttle } from 'lodash'
import STableColumn from './TableColumn.vue'
import useTableData from './hooks/useTableData'
import useTableExpand, { expandFn } from './hooks/useTableExpand'
import useSeletion from './hooks/useSeletion'
import usePagination from './hooks/usePagination'
import useCurrentInstance from './hooks/useCurrentInstance'
import { t } from '@/plugins/i18n'
import { hasScroll } from '@/util/useScrollTo'
import { isShowBySite, useSite } from '@/store'

const __default__ = defineComponent({
  name: 'STable'
})

function setup(__props, { expose, emit: emits }) {

const props = __props



const { proxy } = useCurrentInstance()
const customSlots = reactive({
  ...proxy?.$slots
})
console.log('proxy?.$slots', proxy?.$slots)
const commonTableRef = ref<HTMLElement | null>(null)

const _tableConfig = computed(() => {
  let result: any = {}
  const _tableConfig = { label: t('操作'), minWidth: 200, align: 'center', fixed: 'right' }
  props.tableConfig.handlerConfig &&
    Object.assign(_tableConfig, props.tableConfig.handlerConfig)
  const config = {
    rowKey: 'id',
    isCheckMemory: false,
    showSelection: false,
    showExpand: false,
    showHandler: false,
    setHeight: false
  }
  result = Object.assign(config, props.tableConfig)
  result.handlerConfig = _tableConfig
  return result
})
const _paginationConfig = computed(() => {
  const config = {
    total: 0,
    current: 1,
    pageSize: 30,
    pageSizes: [10, 20, 30, 50],
    layout: ' prev, pager, next, sizes, jumper ',
    background: true
  }
  return Object.assign(config, props.paginationConfig)
})

const _columns = computed(() => {
  return props.columns.map((e: any) => ({
    minWidth: 100,
    ...e
  })).filter(isShowBySite)
})
const filterColumns = computed(() => {
  if (props.showTableFilter) {
    return filterColumnsKey.value.length ? _columns.value.filter(v => filterColumnsKey.value.includes(v.prop)) : _columns.value
  }
  return _columns.value
})
const {
  getData,
  clearData,
  tableCount,
  tableData: _tableData,
  loading,
  apiData
} = useTableData(commonTableRef, props, (data: any[]) => expandFn(data, _tableConfig))
const {
  handleSelectionChange,
  clearSelection,
  toggleAllSelection,
  handleSortChange,
  handleRowClick,
  toggleRowSelection
} = useSeletion(commonTableRef, _tableConfig, emits)

const {
  expandRowKeys,
  expandAllChange,
  expandRowChange,
  setExpandAll,
  setExpandRow,
  isAllFilp,
  isAnimationAllFilp,
  isAnimationAllBack,
  isFilp,
  isAnimationFilp,
  isAnimationBack
} = useTableExpand(_tableData, _tableConfig, emits)

const { pageSize, currentPage } = usePagination(props, emits, getData)

onMounted(() => {
  if (props.isImmediatelyExec) {
    getData && getData()
  }
  window.addEventListener('scroll', handleScroll, true)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll, true)
})
watch(_tableData, () => {
  emits('dataListener', toRaw(_tableData.value), toRaw(apiData.value))
  if (props.isClearSelection) {
    clearSelection && clearSelection()
  }
  if (props.isCloseExpand) {
    setExpandAll && setExpandAll(false)
  }
})

const handleScroll = throttle((e: any) => {
  const isPath = ['AssociatedProductlib'].includes(_tableConfig.value?.path)
  if (_tableConfig.value.setHeight && isPath && commonTableRef.value?.$el) {
    const tableDom = commonTableRef.value.$el
    const tableHeadDom = tableDom.children[0].children[1]
    const tableBodyDom = tableDom.children[0].children[2]
    if (tableDom.getBoundingClientRect().height) {
      const getTable2Top = tableDom.getBoundingClientRect().top - 44
      if (getTable2Top <= 0) {
        tableHeadDom.classList.add('headFixed')
        // tableBodyDom.classList.add('bodyFixed')
        tableHeadDom.style.width = `${tableBodyDom.offsetWidth}px`
      } else {
        tableHeadDom.classList.remove('headFixed')
        // tableBodyDom.classList.remove('bodyFixed')
        tableHeadDom.style.width = 'auto'
      }
    }
  }
}, 16, { leading: false })
const defaultFilterKey = window.localStorage.getItem(props.defaultFilterKey + '_table_filter_keys')?.split(',')
const filterColumnsKey = ref(defaultFilterKey ?? [])
const getNewColumnKey = (keys:any) => {
  console.log(keys)
  filterColumnsKey.value = keys
  window.localStorage.setItem(props.defaultFilterKey + '_table_filter_keys', keys?.join(','))
}
expose({
  getData,
  clearData,
  setExpandAll,
  setExpandRow,
  handleSelectionChange,
  handleRowClick,
  clearSelection,
  toggleAllSelection,
  expandAllChange,
  tableData: _tableData,
  toggleRowSelection,
  expandRowChange,
  isFilp
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    id: "STable",
    class: _normalizeClass({'stable-scrollbar-horizontal': _unref(_tableConfig).setHeight, [_unref(useSite)()]: true})
  }, [
    (__props.showTableFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TableColumnFilter, {
            defaultColumns: _unref(_columns),
            onSubmit: getNewColumnKey,
            defaultKey: filterColumnsKey.value
          }, null, 8, ["defaultColumns", "defaultKey"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_el_table, _mergeProps({
      ref: (_value, _refs) => {
        _refs['commonTableRef'] = _value
        commonTableRef.value = _value
      },
      data: _unref(_tableData),
      style: {"width":"100%"},
      "expand-row-keys": _unref(_tableConfig).showExpand ? _unref(expandRowKeys) : undefined,
      "scrollbar-always-on": ""
    }, _ctx.$attrs, {
      rowKey: _unref(_tableConfig).rowKey,
      onRowClick: _unref(handleRowClick),
      onSelectionChange: _unref(handleSelectionChange),
      onSortChange: _unref(handleSortChange),
      "row-class-name": __props.tableRowClassName,
      height: _unref(_tableConfig)?.height
    }), {
      empty: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tableEmpty")
      ]),
      default: _withCtx(() => [
        (_unref(_tableConfig).showSelection)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              fixed: "left",
              align: "center",
              type: "selection",
              width: "50",
              selectable: _unref(_tableConfig).selectable,
              "reserve-selection": _unref(_tableConfig).isCheckMemory
            }, null, 8, ["selectable", "reserve-selection"]))
          : _createCommentVNode("", true),
        (_unref(_tableConfig).showExpand)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: "50",
              fixed: "left"
            }, {
              header: _withCtx(() => [
                (__props.showAllExpand)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      class: _normalizeClass([
              'expandIcon',
              { is_flip: _unref(isAllFilp) },
              { flip: _unref(isAnimationAllFilp) },
              { back: _unref(isAnimationAllBack) }
            ]),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(expandAllChange) && _unref(expandAllChange)(...args)), ["stop"])),
                      viewBox: "0 0 1024 1024",
                      xmlns: "http://www.w3.org/2000/svg",
                      "data-v-ba633cb8": ""
                    }, _hoisted_3, 2))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(({ row }) => [
                (!row.noExpand)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      class: _normalizeClass([
              'expandIcon',
              { is_flip: _unref(isFilp)(row) },
              { flip: _unref(isAnimationFilp)(row) },
              { back: _unref(isAnimationBack)(row) }
            ]),
                      onClick: _withModifiers(($event: any) => (_unref(expandRowChange)(row)), ["stop"]),
                      viewBox: "0 0 1024 1024",
                      xmlns: "http://www.w3.org/2000/svg",
                      "data-v-ba633cb8": ""
                    }, _hoisted_6, 10, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(_tableConfig).showExpand)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              type: "expand",
              width: "1"
            }, {
              default: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, "expand", { scope: scope })
              ]),
              _: 3
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterColumns), (column) => {
          return (_openBlock(), _createBlock(STableColumn, {
            key: column.prop,
            column: column
          }, _createSlots({ _: 2 }, [
            _renderList(Object.keys(_unref(customSlots)), (slot) => {
              return {
                name: slot,
                fn: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, slot, _mergeProps(scope, { column: column }), () => [
                    _hoisted_7
                  ])
                ])
              }
            })
          ]), 1032, ["column"]))
        }), 128)),
        (_unref(_tableConfig).showHandler)
          ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({ key: 3 }, _unref(_tableConfig).handlerConfig, { width: "234" }), _createSlots({
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["handlerBox", _unref(useSite)()])
                }, [
                  _renderSlot(_ctx.$slots, "handler", { scope: scope })
                ], 2)
              ]),
              _: 2
            }, [
              (_unref(_tableConfig).handlerConfig.handlerHead)
                ? {
                    name: "header",
                    fn: _withCtx((scope) => [
                      _renderSlot(_ctx.$slots, "handlerHead", { scope: scope })
                    ])
                  }
                : undefined
            ]), 1040))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["data", "expand-row-keys", "rowKey", "onRowClick", "onSelectionChange", "onSortChange", "row-class-name", "height"]), [
      [_directive_loading, _unref(loading)]
    ]),
    (__props.showPagination)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "pagination flex-bwn",
          style: _normalizeStyle(__props.page_position==='left'&&' justify-content:left')
        }, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "footBoxSlot")
          ]),
          _createVNode(_component_el_pagination, _mergeProps(_unref(_paginationConfig), {
            total: _unref(tableCount),
            pageSize: _unref(pageSize),
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : null)),
            currentPage: _unref(currentPage),
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null))
          }), null, 16, ["total", "pageSize", "currentPage"])
        ], 4))
      : _createCommentVNode("", true)
  ], 2))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  tableRowClassName: {
    type: [String, Function],
    default: ''
  },
  page_position: { type: String },
  // 接口
  api: {
    type: Function
  },
  // 列表数据
  tableData: {
    type: Array,
    default: () => []
  },
  // 列表表头
  columns: {
    type: Array,
    require: true,
    default: () => []
  },
  // 筛选条件数据
  filterData: {
    type: Object,
    default: () => ({})
  },
  // 是否显示分页
  showPagination: {
    type: Boolean,
    require: true,
    default: true
  },
  // 分页数据
  pageData: {
    type: Object,
    default: () => ({
      limit: 30,
      page: 1
    })
  },
  /**
   * 导出的配置项
   * totalPath: 接口返回的总数路径
   * listPath:  接口返回的列表路径
   * pageName:  分页接口传入的页数
   * limitName:  分页接口传入的每页条数
   */
  apiConfig: {
    type: Object,
    default: () => ({})
  },
  /**
   * rowKey: 'id', //   行数据的 Key，用来优化 Table 的渲染
   * isCheckMemory: false, // 是否需要跨页勾选
   * showSelection: false, // 是否多选
   * showExpand: false, // 是否是展开
   * expandConfigId  // 显示隐藏行展开key
   * showHandler: false // 是否需要显示操作栏
   * selectable: Fn // 是否禁用行函数
   */
  tableConfig: {
    type: Object,
    default: () => ({})
  },
  /**
   * https://element-plus.gitee.io/zh-CN/component/pagination.html#%E5%B1%9E%E6%80%A7
   *
   * total: 0,
   * current: 1,
   * pageSize: 30,
   * pageSizes: [10, 20, 30, 50],
   * layout: ' prev, pager, next, sizes, jumper ',
   * background: true
   */
  paginationConfig: {
    type: Object,
    default: () => ({})
  },
  // 是否立即执行接口
  isImmediatelyExec: {
    type: Boolean,
    default: true
  },
  // 列表数据改变，列表是否关闭展开
  isCloseExpand: {
    type: Boolean,
    default: true
  },
  // 列表数据改变，列表是否清理勾选
  isClearSelection: {
    type: Boolean,
    default: true
  },
  //  是否展示一键展开
  showAllExpand: {
    type: Boolean,
    default: true
  },
  //  是否展示表格筛选
  showTableFilter: {
    type: Boolean,
    default: false
  },
  defaultFilterKey: {
    type: String,
    default: ''
  }
},
  emits: [
  'update:page-data',
  'selection-change',
  'sort-change',
  'expand-all',
  'expand-row',
  'dataListener',
  'row-click'
],
  setup})